import React from 'react';
import './styles/App.css';
import Frame1 from './img/Frame 17.png';
import Frame2 from './img/Frame 17-2.png';
import Frame3 from './img/Frame 17-1.png';
import Frame4 from './img/Frame 18.png';
import Frame5 from './img/Frame 19.png';
import { Link } from 'react-router-dom';


function M_Footer() {
    const isAlert = () => {
        alert("서비스 준비중 입니다.");
    }
    const style = {
        height:'100px'
    }
  return (
    <>
    <div style={style}></div>
    <footer className="container m_footer fixed">
        <div className="F_content d-inline-block" onClick={isAlert}> <img className="F_content_img" src={Frame1}></img>
            <div className="f_content_name">전체 서비스</div>
        </div>
        <div className="F_content d-inline-block" onClick={isAlert}> <img className="F_content_img" src={Frame2}></img>
            <div className="f_content_name">예약/주문</div>
        </div>
        <Link to="/">
            <div className="F_content d-inline-block"> 
                <img className="F_content_img" src={Frame3}></img>
                <div className="f_content_name">홈</div>
            </div>
        </Link>
        <Link to="/service?cate=현대">
            <div className="F_content d-inline-block"> <img className="F_content_img" src={Frame4}></img>
                <div className="f_content_name">서비스 소개</div>
            </div>
        </Link>
        
        <div className="F_content d-inline-block" onClick={isAlert}> <img className="F_content_img" src={Frame5}></img>
            <div className="f_content_name">더보기</div>
        </div>


       

    </footer>
    
      
    </>
  );
}

export default M_Footer;